import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, CheckCircle2, Flame, BookOpen, Droplet, ShoppingCart, Utensils, Calendar } from 'lucide-react';
import { Button } from '../ui/Button';
export function Mechanism() {
  const deliverables = [{
    icon: <BookOpen className="w-8 h-8 text-amber" data-id="element-92" />,
    title: "La Guía Maestra 'Parrillada Sin Dolor'",
    desc: 'PDF de lectura rápida, directo al grano.'
  }, {
    icon: <Droplet className="w-8 h-8 text-amber" data-id="element-93" />,
    title: 'El Código de los Aceites',
    desc: 'Cuáles sanan y cuáles destruyen tus rodillas.'
  }, {
    icon: <ShieldCheck className="w-8 h-8 text-amber" data-id="element-94" />,
    title: "La 'Marinada Escudo'",
    desc: 'La receta exacta para bloquear compuestos inflamatorios.'
  }, {
    icon: <ShoppingCart className="w-8 h-8 text-amber" data-id="element-95" />,
    title: 'Lista de Compras del Parrillero',
    desc: 'Qué cortes elegir y qué evitar en la carnicería.'
  }, {
    icon: <Utensils className="w-8 h-8 text-amber" data-id="element-96" />,
    title: 'Guarniciones de Poder',
    desc: 'Acompañamientos que mantienen tu insulina bajo control.'
  }, {
    icon: <Calendar className="w-8 h-8 text-amber" data-id="element-97" />,
    title: 'El Plan Maestro del Domingo',
    desc: 'Paso a paso desde el encendido hasta la digestión.'
  }];
  return <section className="py-20 bg-dark-warm relative" data-id="element-98">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-20 mix-blend-overlay" data-id="element-99"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-100">
        {/* Unique Mechanism */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-dark border-2 border-amber/40 rounded-2xl p-8 md:p-12 shadow-[0_0_40px_rgba(232,130,12,0.15)] mb-20" data-id="element-101">
          <div className="flex justify-center mb-6" data-id="element-102">
            <Flame className="w-16 h-16 text-amber animate-pulse" data-id="element-103" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-center mb-6 text-white" data-id="element-104">
            El Sistema{' '}
            <span className="text-amber" data-id="element-105">"Grill This, Not That"</span>
          </h2>
          <p className="text-xl text-center text-offwhite/80 mb-8 font-medium" data-id="element-106">
            (Asa esto, no aquello)
          </p>
          <p className="text-lg text-offwhite/90 leading-relaxed text-center max-w-3xl mx-auto" data-id="element-107">
            No vamos a prohibir el asado. Vamos a hackearlo. Mediante el uso de
            aceites de alto punto de humo, marinadas protectoras que bloquean
            toxinas y sustituciones inteligentes de carbohidratos, eliminamos el
            residuo inflamatorio sin sacrificar ni un gramo de sabor. Es la
            ciencia de la química natural aplicada a la parrilla.
          </p>
        </motion.div>

        {/* What You Get */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-108">
          <h2 className="text-3xl md:text-5xl font-bold text-center mb-12" data-id="element-109">
            Lo que obtienes hoy
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-110">
            {deliverables.map((item, idx) => <motion.div key={idx} whileHover={{
            y: -5
          }} className="bg-dark-lighter p-6 rounded-xl border border-white/10 hover:border-amber/50 transition-colors" data-id="element-111">
                <div className="mb-4 bg-dark-warm w-16 h-16 rounded-full flex items-center justify-center border border-amber/20" data-id="element-112">
                  {item.icon}
                </div>
                <h3 className="text-xl font-bold mb-2 text-white" data-id="element-113">
                  {item.title}
                </h3>
                <p className="text-offwhite/70" data-id="element-114">{item.desc}</p>
              </motion.div>)}
          </div>

          <div className="text-center" data-id="element-115">
            <Button data-id="element-116">¡Quiero mi guía parrillada sin dolor!</Button>
          </div>
        </motion.div>
      </div>
    </section>;
}